import React from 'react';
import {
  DEFAULT_COMPOSE_LENGTHS,
  DEFAULT_COMPOSE_PURPOSES,
  DEFAULT_COMPOSE_TONES,
  DEFAULT_LANGUAGES,
  EXAMPLE_PROMPTS,
} from './composeHelpers';

export default function AIComposePrompt({
  prompt,
  onPromptChange,
  tone,
  length,
  language,
  purpose,
  onToneChange,
  onLengthChange,
  onLanguageChange,
  onPurposeChange,
  tones = DEFAULT_COMPOSE_TONES,
  lengths = DEFAULT_COMPOSE_LENGTHS,
  languages = DEFAULT_LANGUAGES,
  purposes = DEFAULT_COMPOSE_PURPOSES,
  disabled = false,
  onGenerate,
  loading = false,
}) {
  return (
    <div className="aic-prompt">
      <div className="aic-field">
        <label className="aic-label" htmlFor="aic-prompt-input">
          What do you want to write?
        </label>
        <textarea
          id="aic-prompt-input"
          className="aic-textarea"
          placeholder='e.g. "Write a leave request for tomorrow."'
          value={prompt}
          disabled={disabled}
          onChange={(e) => onPromptChange(e.target.value)}
        />
        <div className="aic-chips">
          {EXAMPLE_PROMPTS.map((example) => (
            <button
              key={example}
              type="button"
              className="aic-chip"
              disabled={disabled}
              onClick={() => onPromptChange(example)}
            >
              {example}
            </button>
          ))}
        </div>
      </div>

      <div className="aic-grid">
        <div className="aic-field">
          <label className="aic-label" htmlFor="aic-tone">Tone</label>
          <select
            id="aic-tone"
            className="aic-select"
            value={tone}
            disabled={disabled}
            onChange={(e) => onToneChange(e.target.value)}
          >
            {tones.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>
        <div className="aic-field">
          <label className="aic-label" htmlFor="aic-length">Length</label>
          <select
            id="aic-length"
            className="aic-select"
            value={length}
            disabled={disabled}
            onChange={(e) => onLengthChange(e.target.value)}
          >
            {lengths.map((l) => (
              <option key={l} value={l}>{l}</option>
            ))}
          </select>
        </div>
        <div className="aic-field">
          <label className="aic-label" htmlFor="aic-language">Language</label>
          <select
            id="aic-language"
            className="aic-select"
            value={language}
            disabled={disabled}
            onChange={(e) => onLanguageChange(e.target.value)}
          >
            {languages.map((l) => (
              <option key={l} value={l}>{l}</option>
            ))}
          </select>
        </div>
        <div className="aic-field">
          <label className="aic-label" htmlFor="aic-purpose">Purpose</label>
          <select
            id="aic-purpose"
            className="aic-select"
            value={purpose}
            disabled={disabled}
            onChange={(e) => onPurposeChange(e.target.value)}
          >
            {purposes.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="aic-actions-row">
        <button
          type="button"
          className="aic-btn aic-btn-primary"
          disabled={disabled || !String(prompt || '').trim()}
          onClick={onGenerate}
        >
          {loading ? 'Generating…' : 'Generate Email'}
        </button>
      </div>
    </div>
  );
}
